import { atom } from "jotai";

export const filtersAtom = atom<any>({
  dateType: "Last 7 Days",
});
